import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import AddIcon from "@material-ui/icons/Add";
import style from "../../assets/jss/disal-main/Layouts/PointAcopio";
import { usePointAcopio } from "../../Context/PointAcopioContext";

const useStyles = makeStyles(style);

const PointAcopio = () => {
  const { 
    containers,
    containerTypes,
    residueTypes,
    selected,
    setSelected,
    departments,
    doSave,
  } = usePointAcopio();
  
  const classes = useStyles();

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    number: "",
    latitude: "",
    longitude: "",
    gerencia: 0,
    container: 0,
    residue: 0,
    addData: [],
    newData: [],
    error: {
      name: "",
      number: "",
      latitude: "",
      longitude: "",
      gerencia: "",
      addData: ""
    }
  });

  const initializeFormData = (propsData, containerData) => {
    if (Object.values(propsData).length > 0) {
      const estructureArray = containerData.map(res => ({
        containerId: res.containerId,
        collectPointId: res.collectPointId,
        containerModelId: res.containerModelId,
        containerModelName: res.containerModelName,
        ResidualSubTypeId: res.residualSubtypeId,
        residualSubtypeName: res.residualSubtypeName,
        isDeleted: 0
      }));
      
      const estructurenewArray = containerData.map(res => ({
        containerId: res.containerId,
        collectPointId: res.collectPointId,
        containerModelId: res.containerModelId,
        residualSubTypeId: res.residualSubtypeId,
        isDeleted: 0
      }));

      setFormData({
        id: propsData.collectPointId || "",
        name: propsData.collectPointDescription || "",
        number: propsData.pointNumber || "",
        latitude: propsData.latitude || "",
        longitude: propsData.longitude || "",
        gerencia: propsData.departmentId || 0,
        addData: estructureArray,
        newData: estructurenewArray,
        container: 0,
        residue: 0,
        error: {
          name: "",
          number: "",
          latitude: "",
          longitude: "",
          gerencia: "",
          addData: ""
        }
      });
    } else {
      setFormData({
        id: "",
        name: "",
        number: "",
        latitude: "",
        longitude: "",
        gerencia: 0,
        container: 0,
        residue: 0,
        addData: [],
        newData: [],
        error: {
          name: "",
          number: "",
          latitude: "",
          longitude: "",
          gerencia: "",
          addData: ""
        }
      });
    }
  };

  useEffect(() => {
    initializeFormData(selected, containers);
  }, [selected, containers]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const regex_numeros = /[0-9]/;
    const RE = /^-?(?:\d+(?:.\d{0,8})?)$/;

    if (name === "number") {
      if (regex_numeros.test(value) || value === "") {
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      }
    } else if (name === "latitude") {
      if (RE.test(value) || value === "") {
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleChangeSelect = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = async () => {
    const { newData, error } = formData;
    const data = {
      collectPointDescription: formData.name,
      pointNumber: Number(formData.number),
      latitude: Number(
        Number.parseFloat(Number(formData.latitude)).toFixed(8)
      ),
      longitude: Number(
        Number.parseFloat(Number(formData.longitude)).toFixed(8)
      ),
      departmentId: formData.gerencia
    };

    const newResult = formData.id !== "" ? Object.assign(data, { id: formData.id }) : data;
    
    const newError = { ...error };
    
    if (formData.name === "") {
      newError.name = "*Completar campo";
    } else {
      newError.name = "";
    }
    if (formData.number === "") {
      newError.number = "*Completar campo";
    } else {
      newError.number = "";
    }
    if (formData.latitude === "") {
      newError.latitude = "*Completar campo";
    } else {
      newError.latitude = "";
    }
    if (formData.longitude === "") {
      newError.longitude = "*Completar campo";
    } else {
      newError.longitude = "";
    }
    if (formData.gerencia === 0) {
      newError.gerencia = "*Seleccione una opción";
    } else {
      newError.gerencia = "";
    }
    
    setFormData(prev => ({
      ...prev,
      error: newError
    }));

    if (
      formData.name !== "" &&
      formData.number !== "" &&
      formData.longitude !== "" &&
      formData.latitude !== "" &&
      formData.gerencia !== 0
    ) {

      doSave(newResult, newData);
    }
  };

  const handleAdd = () => {
    const { container, residue, addData, newData, error } = formData;
    const getContainerName = containerTypes.filter(
      res => res.containerModelId === container
    );
    const getResidueName = residueTypes.filter(
      res => res.WasteSubTypeId === residue
    );

    const newError = { ...error };
    if (container === 0 || residue === 0) {
      newError.addData = "*Selecciona ambas opciones";
    } else {
      newError.addData = "";
    }

    if (container !== 0 && residue !== 0) {
      const newAddData = [...addData, {
        containerModelId: container,
        containerModelName: getContainerName[0].containerModelName,
        ResidualSubtypeId: residue,
        residualSubtypeName: getResidueName[0].WasteSubTypeName
      }];
      
      const newNewData = [...newData, {
        containerModelId: container,
        residualSubTypeId: residue,
        isDeleted: 0
      }];

      setFormData(prev => ({
        ...prev,
        addData: newAddData,
        newData: newNewData,
        error: { ...prev.error, addData: "" },
        container: 0,
        residue: 0
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        error: newError
      }));
    }
  };

  const handleDelete = (e) => {
    const { addData, newData } = formData;
    const id = e.currentTarget.id;
    const name = e.currentTarget.name;
    
    if (name === "non") {
      const newResult = addData.filter((res, index) => index !== Number(id));
      const newResultAdd = newData.map((res, index) => {
        if (index === Number(id)) {
          return { ...res, isDeleted: 1 };
        }
        return res;
      });

      setFormData(prev => ({
        ...prev,
        addData: newResult,
        newData: newResultAdd
      }));
    } else {
      const newResult = addData.filter(res => res.containerId !== Number(id));
      const newResultAdd = newData.map(res => {
        if (res.containerId === Number(id)) {
          return { ...res, isDeleted: 1 };
        }
        return res;
      });

      setFormData(prev => ({
        ...prev,
        addData: newResult,
        newData: newResultAdd
      }));
    }
  };

  return (
    <div className={classes.contentForm}>
      <Grid container>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={2}>
                <label>ID </label>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  disabled
                  name="id"
                  value={formData.id}
                  onChange={handleChange}
                  variant="outlined"
                  className={classes.textFielInput + " blocked-id"}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={2}>
                <label>Nombre </label>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  variant="outlined"
                  inputProps={{
                    maxLength: 100
                  }}
                  className={classes.textFielInput}
                />
                <p>
                  {formData.error.name === undefined
                    ? ""
                    : formData.error.name}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={2}>
                <label>Número </label>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  name="number"
                  value={formData.number}
                  inputProps={{
                    maxLength: 10
                  }}
                  onChange={handleChange}
                  variant="outlined"
                  className={classes.textFielInput}
                />
                <p>
                  {formData.error.number === ""
                    ? formData.error.messageSave !== undefined
                      ? formData.error.messageSave
                      : null
                    : formData.error.number}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={4}>
                <label>Latitude </label>
              </Grid>
              <Grid item xs={7}>
                <TextField
                  name="latitude"
                  value={formData.latitude}
                  onChange={handleChange}
                  variant="outlined"
                  className={classes.textFielInput}
                />
                <p>
                  {formData.error.latitude === undefined
                    ? ""
                    : formData.error.latitude}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={6} style={{ paddingLeft: "15px" }}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={4}>
                <label>Longitude </label>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  name="longitude"
                  value={formData.longitude}
                  onChange={handleChange}
                  variant="outlined"
                  className={classes.textFielInput}
                />
                <p>
                  {formData.error.longitude === undefined
                    ? ""
                    : formData.error.longitude}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={2}>
                <label>Gerencia </label>
              </Grid>
              <Grid item xs={10}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    name="gerencia"
                    value={formData.gerencia}
                    onChange={handleChange}
                  >
                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                    {departments.map((res, key) => {
                      return (
                        <MenuItem key={key} value={res.departmentId}>
                          {res.departmentDescription}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <p>
                  {formData.error.gerencia === undefined
                    ? ""
                    : formData.error.gerencia}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <div>
        <h3 className={classes.title}>Contenedores</h3>

        <Grid container>
          <Grid item xs={12} className={classes.detailItem}>
            <Grid container>
              <Grid item xs={1}>
                <p>#</p>
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  paddingRight: "10px"
                }}
              >
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    name="container"
                    value={formData.container}
                    onChange={handleChangeSelect}
                  >
                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                    {containerTypes.map((res, key) => {
                      return (
                        <MenuItem key={key} value={res.containerModelId}>
                          {res.containerModelName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  paddingLeft: "10px"
                }}
              >
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    name="residue"
                    value={formData.residue}
                    onChange={handleChangeSelect}
                  >
                    <MenuItem value={0}>Selecciona una opción</MenuItem>
                    {residueTypes.map((res, key) => {
                      return (
                        <MenuItem key={key} value={res.WasteSubTypeId}>
                          {res.WasteSubTypeName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <button
                  onClick={handleAdd}
                  className={classes.iconAddContent}
                >
                  <AddIcon />
                </button>
              </Grid>
              <p className="err">{formData.error.addData}</p>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.listContent}>
            <List className={classes.listContainer}>
              <Grid container>
                {formData.addData.map((val, index) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      className={classes.detailItem}
                      key={index}
                    >
                      <Grid container>
                        <Grid item xs={1}>
                          <p>
                            {val.containerId === undefined
                              ? "#"
                              : val.containerId}
                          </p>
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          style={{
                            paddingRight: "10px"
                          }}
                        >
                          <p>{val.containerModelName}</p>
                        </Grid>
                        <Grid
                          item
                          xs={5}
                          style={{
                            paddingLeft: "10px"
                          }}
                        >
                          <p>{val.residualSubtypeName}</p>
                        </Grid>
                        <Grid item xs={1}>
                          <button
                            id={
                              val.containerId === undefined
                                ? index
                                : val.containerId
                            }
                            name={
                              val.containerId === undefined ? "non" : "yes"
                            }
                            onClick={handleDelete}
                            className={classes.iconDelete}
                          >
                            <CloseIcon />
                          </button>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </List>
          </Grid>
        </Grid>
      </div>

      <div className={classes.contentButton}>
        <button onClick={() => setSelected(null)}>Cancelar</button>
        <button onClick={handleSave}>Guardar</button>
      </div>
    </div>
  );
};

export default PointAcopio;
